import { render, staticRenderFns } from "./CommonTitle.vue?vue&type=template&id=18b2014e&scoped=true"
import script from "./CommonTitle.vue?vue&type=script&lang=js"
export * from "./CommonTitle.vue?vue&type=script&lang=js"
import style0 from "./CommonTitle.vue?vue&type=style&index=0&id=18b2014e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b2014e",
  null
  
)

export default component.exports